export default __webpack_public_path__ + "static/media/clear-grey.32714f4a.svg";